import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import React from 'react'

import { linkBuilder } from '@/components/Link/linkBuilder'
import { useCities } from '@/context/Cities'

type Props = {
  cityValue: string
  slug: string
  zoneSlug?: string
}

const ListingDetailLink: React.FC<Props> = (props) => {
  const { lang } = useTranslation()
  const cities = useCities()
  return (
    <Link passHref href={linkBuilder.listingDetail.url(lang, props.slug)}>
      {props.children}
    </Link>
  )
}

export default ListingDetailLink
